import React from 'react';
import { useDispatch } from 'react-redux';

import DateRangePickerComponent from '@components/filterComponents/DateRangePickerComponent';

import { objForPODateRange } from '@features/filter/static/filterUtil';

import { storeItemInGlobalFilter } from '@store/actions/FilterAction';

const PoReceivedDate = () => {
	const dispatch = useDispatch();

	const onChangeDateRange = async (name, type, paramName1, paramName2, value1, value2) => {
		let dateRange = {
			name: 'poReceivedDate',
			type: 'dateRange',
			key: value1 + ',' + value2,
			value: value1 + ' - ' + value2,
			identifier: 'poReceivedFilterDateRange'
		};
		dispatch(storeItemInGlobalFilter(dateRange));
	};

	return <DateRangePickerComponent item={{ ...objForPODateRange }} onChange={onChangeDateRange} />;
};

export default PoReceivedDate;
